// extracted by mini-css-extract-plugin
var _1 = "Padding_bottom__ccc24";
var _2 = "Padding_bottomSpace__0a672";
var _3 = "Padding_fluid__91dae";
var _4 = "Padding_gap__a40c4";
var _5 = "Padding_root__65111";
var _6 = "Padding_side__08f79";
var _7 = "Padding_top__26932";
export { _1 as "bottom", _2 as "bottomSpace", _3 as "fluid", _4 as "gap", _5 as "root", _6 as "side", _7 as "top" }
